import { api } from '../services/api';
import { FETCH_ELEMENTO_PATH } from '../services/path';
import {
  FETCH_ELEMENTO, FETCH_ELEMENTO_BY_ID, FETCH_ELEMENTO_BY_ID_GRAFICA, LIMPIAR_ESTADO_ELEMENTO
} from './types';

export const fetchElemento = (perPage, offSet) => (dispatch) => dispatch({
  type: FETCH_ELEMENTO,
  promise: api.get(`${FETCH_ELEMENTO_PATH}?perPage=${perPage}&offSet=${offSet}`)
});

export const fetchElementoById = (id) => (dispatch) => dispatch({
  type: FETCH_ELEMENTO_BY_ID,
  promise: api.get(`${FETCH_ELEMENTO_PATH}/${id}`)
});

export const fetchElementoByIdGrafica = (id) => (dispatch) => dispatch({
  type: FETCH_ELEMENTO_BY_ID_GRAFICA,
  promise: api.get(`${FETCH_ELEMENTO_PATH}/${id}`)
});
export const limpiarElemento = () => (dispatch) => dispatch({
  type: LIMPIAR_ESTADO_ELEMENTO,
});
